import {
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid2,
    Icon,
    TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { getDate, getDateString } from "../../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { clientFollowUpsService } from "../../../_services/clientFollowUp.service";
import { accountService } from "../../../_services/accounts.service";

export function ClientFollowUpsManage(params: { onSave(): void }) {

    const resetData = () => ({});

    const { id } = useParams<{ id: string }>();

    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        if (id != null) fetchData();
        else setData(resetData);
    }, [id]);

    function fetchData() {
        if (!id) return;
        setIsLoading(true);
        return clientFollowUpsService
            .get(id)
            .then(
                (json) => {
                    setData(json);
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const _data = { ...data, clientId: id };

        return clientFollowUpsService
            .put(_data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    setData(resetData());
                    setShowForm(false);
                    params.onSave();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    const addNew = () => {
        setData(resetData());
        setShowForm(true);
    };

    const cancel = () => {
        setShowForm(false);
        setData(resetData());
    };

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Box p={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6"></Typography>
                {!showForm && (
                    <Button variant="contained" onClick={addNew}>
                        Add Comment
                    </Button>
                )}
            </Box>

            {showForm && (
                <ValidatorForm onSubmit={submit} noValidate>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                name="nextActionDate"
                                label="Next Action Date"
                                type="date"
                                fullWidth
                                value={data.nextActionDate}
                                onChange={handleChange}
                            />
                        </Grid2>

                        {!accountService.isAgent &&
                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    name="comment"
                                    label="Comment"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data.comment}
                                    onChange={handleChange}
                                />
                            </Grid2>
                        }

                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="save"
                                type="submit"
                            >
                                Save
                            </StandardButton>
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="block"
                                variant="error"
                                onClick={cancel}>
                                Cancel
                            </StandardButton>
                        </Grid2>
                    </Grid2>
                </ValidatorForm>
            )}

            <Box mt={4}>
                <Grid2 container spacing={2} mt={1}>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            name="actionDate"
                            label="Action Date"
                            fullWidth
                            disabled
                            value={data.actionDate != null ? getDate(data.actionDate) : ""}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            name="commentHistory"
                            label="Comment History"
                            fullWidth
                            multiline
                            rows={24}
                            disabled
                            value={data.commentHistory}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid2>
                </Grid2>
            </Box>
        </Box>
    );
}
